import AsyncConversationAssistant from '@atlassian/conversation-assistant/AsyncConversationAssistant';
import { preloadChatOnIntent } from '@atlassian/conversation-assistant/preload-chat-on-intent';

const CHAT_ROUTE = '/extension/rovo-chat';

/**
 * Warms both conversation-assistant chunks at entry time rather than when React reaches their lazy
 * boundaries, which today is only after `/api/me` and Statsig have resolved. The chat route always
 * renders the chat UI, so both chunks are certain to be needed. See ASIMO-5179.
 */
export const preloadChatBundles = (): void => {
	if (window.location.pathname !== CHAT_ROUTE) {
		return;
	}

	// The shell chunk, behind `AsyncConversationAssistant`.
	AsyncConversationAssistant.preload();
	// The chat UI chunk, behind `ConversationAssistantUILazy` inside the configurer.
	preloadChatOnIntent();
};
